module.exports = __webpack_public_path__ + "static/media/executive.a7547f45.png";